<template>
 <div class="c-spinner-wrapper">
   <div class="c-spinner-ring" :style="spinnerStyle"></div>
 </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 10,
    },
    weight: {
      type: Number,
      default: 2,
    },
    color: {
      type: String,
      default: 'black',
    },
  },

  computed: {
    spinnerStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        'border-width': `${this.weight}px`,
        'border-color': `${this.color} transparent transparent transparent`,
      };
    },
  },
};
</script>


<style lang="scss">
.c-spinner-wrapper {
  display: inline-block;
  position: relative;
}

.c-spinner-ring {
  position: relative;
  text-indent: -9999em;
  border-radius: 50%;
  border-top: 2px solid rgba(0,0,0, 0.2);
  border-right: 2px solid rgba(0,0,0, 0.2);
  border-bottom: 2px solid rgba(0,0,0, 0.2);
  border-left: 2px solid #000;
  transform: translateZ(0);
  animation: spiner-animation .8s infinite linear;
}

@keyframes spiner-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
